// No custom JS needed — Bootstrap badges are purely CSS.
